import InvoiceType from 'bz-pronto-core/enum/invoice-type';
import ProntoInvoiceStatus from 'bz-pronto-core/enum/pronto-invoice-status';
import GUID from 'bz-utilities/modules/variables/guid';
import { computed } from 'mobx';
import React from 'react';

class EditPayments extends React.Component {
  render() {
    return !!this.show ? this.props.children : null;
  }

  @computed
  get show() {
    const { invoice = {} } = this.props;
    const { globalId, globalType, metadata = {} } = invoice;

    if (globalType !== InvoiceType.Pronto) return true;
    if (!globalId || GUID.isEmpty(globalId)) return false;

    return [ProntoInvoiceStatus.Accepted, ProntoInvoiceStatus.Saved].includes(metadata.status);
  }
}

export default EditPayments;
